import React, { useState } from "react";

export default function ProductGallery({ images, name }) {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div>
      <div className="product-main-image">
        <img src={images[activeIndex]} alt={name} />
      </div>
      {images.length > 1 && (
        <div className="product-thumb-row">
          {images.map((img, i) => (
            <button
              key={i}
              type="button"
              className={`product-thumb ${i === activeIndex ? "active" : ""}`}
              onClick={() => setActiveIndex(i)}
            >
              <img src={img} alt={`${name} view ${i + 1}`} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
